
<div class="subscription">
    <div class="ds-accounts-body-box-title" *ngIf="!noText">
        {{ 'CARD_ALREADY_LINKED_CARD_YOU_CAN_PURCHASE_PLAN' | translate }}
    </div>
    <br *ngIf="!noText">
    <div class="subscription-card">
        <div style="display: flex;">
            <div>
                <div class="subscription-card-title">
                   {{"CARD_TYPE" | translate}} {{userCard?.funding === 'credit' ? 'Crédito' : 'Débito' }}
                </div>
                <div class="subscription-card-subtitle">
                    {{userCard?.brand}} **** **** **** {{userCard?.last4}}
                </div>
            </div>
            <div>
                <div *ngIf="userCard?.brand=== 'Visa'">
                    <img src="../../../assets/visa.svg" alt="" style="margin-left: 15px;width: 70px;">
                </div>
                <div *ngIf="userCard?.brand=== 'MasterCard'">
                    <img src="../../../assets/mastercard.png" alt="" style="margin-left: 15px;width: 70px;">
                    
                </div>

            </div>
        </div>
        <br>
        <div *ngIf="!changeCard">
            <ion-button color="danger" fill="outline" size="small" (click)="changeCard=true"> {{"CHANGE_CARD" | translate}}</ion-button>
        </div>
    </div>
    <div class="subscription-changecard" *ngIf="changeCard">
        <div> {{"INSERT_NEW_CARD_DETAILS" | translate}}</div>
        <ion-button fill="outline" size="small" (click)="changeCard=false"> {{"GO_BACK" | translate}}</ion-button>
        <app-stripe-card (uploadCardFinish)="uploadCardFinish()"></app-stripe-card>
    </div>



</div>
